"use client";

import { Core } from "@faire/design-tokens";
import { strictLocalize } from "@faire/web/common/localization";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1460))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.668Z
 */
export const File = createSVGIcon(
  <>
    <path
      d="M21.4284 21.4289C21.4284 21.8835 21.2478 22.3195 20.9263 22.641C20.6048 22.9625 20.1688 23.1431 19.7141 23.1431H4.28557C3.83092 23.1431 3.39488 22.9625 3.07339 22.641C2.7519 22.3195 2.57129 21.8835 2.57129 21.4289V2.57171C2.57129 2.11705 2.7519 1.68102 3.07339 1.35952C3.39488 1.03803 3.83092 0.857422 4.28557 0.857422H12.857L21.4284 9.42885V21.4289Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8574 0.857422V9.42885H21.4288"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "File",
  {
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "File",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: Core.icon.default,
  }
);
